/**
 * 卡牌增强配置
 * 增强类型的视觉样式、标签、颜色
 */

import type { CardEnhancement } from '../engine/types'

export const ENHANCEMENT_STYLES: Record<CardEnhancement, { label: string; techLabel: string; effect: string; glow: string; overlay: string; color: string }> = {
  none: { label: '', techLabel: '', effect: '', glow: '', overlay: '', color: '' },
  foil: {
    label: 'Foil',
    techLabel: 'Cloud',
    effect: '+50 Chips',
    glow: '0 0 14px rgba(255,153,0,0.4)',
    overlay: 'bg-gradient-to-br from-orange-400/15 via-transparent to-orange-300/10',
    color: '#FF9900',
  },
  holo: {
    label: 'Holo',
    techLabel: 'Hybrid',
    effect: '+10 Mult',
    glow: '0 0 14px rgba(0,120,212,0.4)',
    overlay: 'bg-gradient-to-br from-blue-400/15 via-transparent to-blue-300/10',
    color: '#0078D4',
  },
  polychrome: {
    label: 'Poly',
    techLabel: 'Multi',
    effect: '×1.5 Mult',
    glow: '0 0 18px rgba(66,133,244,0.5)',
    overlay: 'bg-gradient-to-br from-blue-300/12 via-sky-200/8 to-blue-400/12',
    color: '#4285F4',
  },
  glass: {
    label: 'Glass',
    techLabel: 'Container',
    effect: 'card.glassEffect',
    glow: '0 0 12px rgba(36,150,237,0.35)',
    overlay: 'bg-gradient-to-b from-sky-300/20 to-transparent',
    color: '#2496ED',
  },
  steel: {
    label: 'Steel',
    techLabel: 'K8s',
    effect: 'card.steelEffect',
    glow: '0 0 12px rgba(160,170,190,0.35)',
    overlay: '',
    color: '#8090a0',
  },
}

export const ENHANCEMENT_LABELS: Record<CardEnhancement, string> = {
  none: 'Normal',
  foil: 'Foil',
  holo: 'Holo',
  polychrome: 'Polychrome',
  glass: 'Glass',
  steel: 'Steel',
}

export const ENHANCEMENT_COLORS: Record<CardEnhancement, string> = {
  none: 'rgba(180,170,200,0.6)',
  foil: '#7CAFC2',
  holo: '#D4849A',
  polychrome: '#C9A96E',
  glass: '#88CCEE',
  steel: '#A0B0C0',
}
